export default __webpack_public_path__ + "static/media/link.ab39afd6.svg";